import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApproveRemoveIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 9.5C7.60218 9.5 7.22064 9.34196 6.93934 9.06066C6.65804 8.77936 6.5 8.39782 6.5 8C6.5 7.60218 6.65804 7.22064 6.93934 6.93934C7.22064 6.65804 7.60218 6.5 8 6.5C8.39782 6.5 8.77936 6.65804 9.06066 6.93934C9.34196 7.22064 9.5 7.60218 9.5 8C9.5 8.39782 9.34196 8.77936 9.06066 9.06066C8.77936 9.34196 8.39782 9.5 8 9.5Z",
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99801 3.00098C6.54159 3.00181 5.12129 3.45708 3.93551 4.30273C2.74977 5.14847 1.8569 6.34294 1.3818 7.71973C1.28582 7.99893 1.36341 8.28067 1.47338 8.54735C1.5267 8.67664 1.67952 8.73031 1.80793 8.6749C2.76022 8.26401 3.76068 8.10034 4.69229 8.20646C4.85626 8.22514 5.0027 8.09222 5.00676 7.92723C5.02549 7.16672 5.33172 6.42534 5.87789 5.87891C6.44039 5.31641 7.20449 5.00013 7.99996 5C8.79534 5.00012 9.55857 5.31655 10.1211 5.87891C10.6835 6.44149 11 7.20445 11 8C11 8.79554 10.6835 9.5585 10.1211 10.1211C9.69396 10.5481 9.14788 10.828 8.56655 10.9393C8.41912 10.9675 8.31619 11.1087 8.33905 11.2571C8.41129 11.7258 8.41081 12.2131 8.35844 12.6851C8.34098 12.8426 8.46578 12.9827 8.62355 12.9685C9.85588 12.8579 11.0503 12.4229 12.0664 11.6982C13.2524 10.8522 14.1451 9.65746 14.6201 8.28027C14.6832 8.09688 14.6822 7.89726 14.6191 7.71387C14.1427 6.33741 13.2491 5.14349 12.0625 4.29883C10.8758 3.45426 9.45458 3.00032 7.99801 3.00098Z",
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M2.75 11.25H5.75V13.25C5.75 13.8023 5.30228 14.25 4.75 14.25H3.75C3.19772 14.25 2.75 13.8023 2.75 13.25V11.25Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 11.25H6.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.75 10L4.75 10L4.75 10.9953L3.75 10.9953L3.75 10Z" })
	]
});
export default SvgApproveRemoveIcon;
